import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import { withPixelLineHeight } from '../../../styles/functions.web';
const useStyles = makeStyles()(theme => {
    return {
        // Place CSS here.
        formControl: {
            ...withPixelLineHeight(theme.typography.bodyLongRegular),
            color: theme.palette.text01,
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.875rem',
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyLongRegularLarge)
            }
        },
        controlColumn: {
            flex: '1 1 auto'
        },
        labelColumn: {
            flex: '0 0 50%',
            fontSize: '1rem'
        },
        labelFormat: {
            fontWeight: '400 !important'
        }
    };
});
const Slider = ({ className, disabled, id, label, name, defaultValue, min, max, step, onChange }) => {
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    return (React.createElement("div", { className: cx(styles.formControl, isMobile && 'is-mobile', className) },
        React.createElement("div", { className: styles.labelColumn },
            React.createElement("label", { className: cx(styles.labelFormat, isMobile && 'is-mobile', className), htmlFor: id }, label)),
        React.createElement("div", { className: styles.controlColumn },
            React.createElement("input", { id: id, defaultValue: defaultValue, disabled: disabled, max: max, min: min, name: name, onChange: onChange, step: step, type: 'range' }))));
};
export default Slider;
